import { withStyles } from '@material-ui/core/styles'
import AccordionSummary from '@material-ui/core/AccordionSummary'

const CustomExpansionPanelSummary = withStyles(theme => ({
  root: {
    backgroundColor: '#e1ecf8',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0 16px'
  },
  content: {
    flexGrow: 0
  },
  expandIcon: {
    position: 'relative',
    padding: 0,
    color: '#26274D',
    '&$expanded': {
      transform: 'rotate(90deg)'
    }
  },
  expanded: {}
}))(AccordionSummary)

export const TitleCustomExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: '#e1ecf8'
  },
  content: {},
  expandIcon: {
  }
})(CustomExpansionPanelSummary)

export const EditTitleCustomExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: '#e1ecf8'
  },
  content: {},
  expandIcon: { 
  }
})(CustomExpansionPanelSummary)

export const SubtitleCustomExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: 'transparent',
    '&$expanded': {
      minHeight: 32,
      height: 32
    }
  },
  expandIcon: {
  },
  expanded: {}
})(CustomExpansionPanelSummary)

export default CustomExpansionPanelSummary
